import React from 'react'
import PropTypes from 'prop-types'

import Pagination from 'src/ui/Pagination/Pagination'
import { t } from 'src/lib/i18n-react'

import AchievementsLiveLessonsSkeleton from './AchievementsLiveLessonsSkeleton'
import LiveLessonStats from './subcomponents/AchievementsLiveLessonsStats/AchievementsLiveLessonsStats'
import LiveLessonList from './subcomponents/AchievementsLiveLessonsList/AchievementsLiveLessonsList'

const AchievementsLiveLessons = ({
  statsProps,
  paginationProps,
  liveLessonsData,
}) => {
  return (
    <AchievementsLiveLessonsSkeleton
      headerSection={t('All Live Lessons')}
      statsSection={<LiveLessonStats {...statsProps} />}
      paginationSection={<Pagination {...paginationProps} />}
      listSection={<LiveLessonList liveLessonsData={liveLessonsData} />}
    />
  )
}

AchievementsLiveLessons.propTypes = {
  statsProps: PropTypes.any,
  paginationProps: PropTypes.any,
  liveLessonsData: PropTypes.any,
}

export default AchievementsLiveLessons
